import styled from "styled-components";

export const ServiceProfessionalsCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  .professionals-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }

  .professionals-title {
    font-weight: 600;
    font-size: 0.875rem;
  }

  .professionals-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .professional-chip {
    padding: 0.25rem 0.75rem;
    border-radius: 1rem;
    background: #f0f2f5;
    font-size: 0.8125rem;
    color: #4a4f57;
  }

  .professionals-empty {
    font-size: 0.8125rem;
    color: #8b919a;
  }

  .edit-button {
    border: none;
    background: none;
    color: #1a1a2e;
    font-size: 0.8125rem;
    font-weight: 600;
    cursor: pointer;
    text-decoration: underline;
  }
`;
